import { Container, Title } from './styles';

const FavoriteAnimes = () => (
  <Container>
    <Title>Página actualmente en desarrollo</Title>
  </Container>
);
export default FavoriteAnimes;
